export default __webpack_public_path__ + "static/media/image20.98c9121c.jpeg";